/**
 * Custom WebSocket close codes (4000–4999 range, reserved for applications).
 * Standard codes: https://datatracker.ietf.org/doc/html/rfc6455#section-7.4.1
 */
export const WS_CLOSE_INVALID_TOKEN = 4001;
export const WS_CLOSE_AGENT_NOT_FOUND = 4002;
